import { ProductName, ProductType } from '@chegg/pricing-sdk';
import { SubscriptionType } from '../common/interfaces';

// Helper to find the One Click checkout Product information for purchasing a
// study subscription.
var getStudySubscriptionProduct = function getStudySubscriptionProduct(studySubscriptionType) {
  switch (studySubscriptionType) {
    case SubscriptionType.CHEGG_STUDY_PACK:
      return {
        name: ProductName.CHEGG_STUDY_PACK,
        type: ProductType.CHEGG_STUDY_PACK
      };
    case SubscriptionType.CHEGG_STUDY:
    case SubscriptionType.CHEGG_STUDY_V2:
      return {
        name: ProductName.CHEGG_STUDY,
        type: ProductType.CHEGG_STUDY
      };
    default:
      return null;
  }
};
export default getStudySubscriptionProduct;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/getStudySubscriptionProduct.js
// module id = 4125
// module chunks = 11